<script setup>
const props = defineProps(['field', 'modelValue'])
const emit = defineEmits(['update:modelValue'])
</script>

<template>
<v-switch
	:model-value="modelValue"
	:label="field.label"
	:color="field.color ? field.color : 'primary'"
	@update:model-value="(val) => emit('update:modelValue', val)"
/>
</template>

<style lang="scss" scoped>

</style>